import instObj from '@/backend/axios-instances'

const resource = "/productionsheet"
const instance = instObj.baseInstance

export default {
  get(id, parameters) {
    return instance.get(`${resource}/${id}`, { params: parameters });
  },
  put(id, data, parameters) {
    return instance.put(`${resource}/${id}`, data, { params: parameters });
  },
  delete(id, parameters) {
    return instance.delete(`${resource}/${id}`, { params: parameters });
  },
  attachImage(id, data, parameters) {
    return instance.post(`${resource}/${id}/images`, data, { params: parameters });
  }
}
